var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGnosis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4155_4256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05418 13.6654C7.7439 13.6654 8.41679 13.4355 8.96072 13.0149L4.58689 8.64111C3.53268 10.0037 3.78502 11.9663 5.14764 13.0206C5.69717 13.4355 6.36446 13.6654 7.05418 13.6654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0636 10.542C20.0636 9.85232 19.8337 9.17942 19.4131 8.6355L15.0393 13.0093C16.4019 14.0635 18.3589 13.8112 19.4131 12.4486C19.8337 11.9047 20.0636 11.2318 20.0636 10.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2673 5.78125L20.3327 7.71583C21.8916 9.58312 21.6449 12.3644 19.7776 13.9233C18.1402 15.2915 15.7626 15.2915 14.1252 13.9233L12 16.0485L9.88037 13.9289C8.01308 15.4878 5.23178 15.2411 3.6729 13.3738C2.30467 11.7364 2.30467 9.35882 3.6729 7.72144L2.68037 6.72891L1.73832 5.78125C0.6 7.65415 0 9.80742 0 11.9999C0 18.628 5.37196 23.9999 12 23.9999C18.628 23.9999 24 18.628 24 11.9999C24.0056 9.80742 23.4 7.65415 22.2673 5.78125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6804 3.71769C16.1103 -1.0767 8.51777 -1.25614 3.72338 3.31395C3.58319 3.44853 3.44861 3.58311 3.31964 3.71769C3.02244 4.03171 2.74207 4.35694 2.47852 4.699L12 14.2261L21.5215 4.699C21.2636 4.35694 20.9776 4.03171 20.6804 3.71769ZM12 1.57002C14.8037 1.57002 17.4168 2.65227 19.3795 4.6261L12 12.0055L4.62057 4.6261C6.58319 2.65227 9.19627 1.57002 12 1.57002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4155_4256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosis);
export default __webpack_public_path__ + "static/media/gnosis.b72831eeb7bb3a27854f3292c1ba75cc.svg";
export { ForwardRef as ReactComponent };